import styled from 'styled-components';
import React from 'react';
import { colors } from '../../../defaultTheme';
import H5 from '../../typography/H5';
import query from '../../../const/mediaQueries';
const Container = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 64px;
  background-color: ${colors.white};
  padding: 0 16px;
  box-sizing: border-box;

  @media ${query.greaterThanMedium} {
    padding: 0 40px;
  }
`;
const Header = styled(H5) `
  margin-left: 10px;
`;
const HeaderContainer = styled.div `
  display: flex;
  align-items: center;
`;
const MultiAccountHeader = ({ id, className, title, icon, addAccountButton }) => {
    return (React.createElement(Container, { id: id, className: className },
        React.createElement(HeaderContainer, null,
            !!icon && icon,
            React.createElement(Header, null, title)),
        !!addAccountButton && addAccountButton));
};
export default MultiAccountHeader;
